export function cpSearch() {
  /**
   * CP Search box handler
   */
  if (document.querySelector(".search-box")) {
    let searchCP = (e) => {
      let urlBase = window.location.href
        .replace(/\/page\/[0-9*]/, "")
        .replace(/\/search\:[a-zA-Z\%0-9]*/, "");
      let searchVal =
        "search:" +
        encodeURIComponent(document.querySelector(".search-box input").value);

      if ("/" != urlBase.substr(-1)) {
        urlBase += "/";
      }

      window.location.href = urlBase + searchVal;
    };

    document
      .querySelector(".search-box input")
      .addEventListener("change", searchCP);

    document
      .querySelector(".search-box button")
      .addEventListener("click", searchCP);
  }
}
